export default "__VITE_ASSET__DfnPeDt0__"